import { Deficiency } from "../../types/deficiencies";
import { DeficiencyCard } from "../DeficiencyCard/DeficiencyCard";
import { Swipeable2 } from "../Swipeable2/Swipeable2";

interface DeficiencySwipeProps {
  deficiency: Deficiency;
  handleDelete: (id: string, appointmentId?: string) => void;
  onClick?: () => void;
}

export const DeficiencySwipe = ({
  deficiency,
  handleDelete,
  onClick,
}: DeficiencySwipeProps) => (
  <Swipeable2
    key={`today-${deficiency.id}`}
    onDelete={() => handleDelete(deficiency.id, deficiency.appointmentIds[0])}
  >
    <DeficiencyCard deficiency={deficiency} onClick={onClick} />
  </Swipeable2>
);
